import PropTypes from 'prop-types'

import useNexiaStream from 'hooks/useNexiaStream'
import { useFeaturesContext } from 'hooks/FeaturesContext'

import SystemStatusPanel from 'pages/Device/SystemStatusPanel'
import ZoneStatusPanel from 'pages/Device/ZoneStatusPanel'

const propTypes = {
  deviceId: PropTypes.string.isRequired,
  hasAwairDevice: PropTypes.bool.isRequired,
  reportCache: PropTypes.shape().isRequired
}

const Status = ({ deviceId, hasAwairDevice, reportCache }) => {
  const { enabledFeatures } = useFeaturesContext()
  const { eventData: report } = useNexiaStream(deviceId, 'current_status', reportCache)

  return (
     <>
     {enabledFeatures.includes('system_dashboard') ? (
       <>
         {report && report.zones.length > 1 && (
           <ZoneStatusPanel {...{ ...report, ...hasAwairDevice }}/>
         )}
         <SystemStatusPanel report={report} hasAwairDevice={hasAwairDevice} showAll={true} />
       </>
     ) : (
       <>
         <SystemStatusPanel report={report} hasAwairDevice={hasAwairDevice} showAll={false} />
         {report && report.zones.length > 1 && (
           <ZoneStatusPanel {...{ ...report, ...hasAwairDevice }} />
         )}
       </>
     )}
   </>
  )
}

Status.propTypes = propTypes

export default Status
